<script>
import api from "@/axios";
import Loader from "../components/loader";
import Layout from '../../layouts/main'
import PageHeader from '@/components/page-header'
import appConfig from "@/app.config";
import {representantesChart1, representantesChart2 } from "../components/data-simulados";
import Swal from "sweetalert2";
import { Vue3Lottie } from 'vue3-lottie'
import 'vue3-lottie/dist/style.css'
import AstronautJSON from '@/assets/animations/repres_anim.json'
import exportFromJSON from "export-from-json"
import moment from "moment/moment";
import {helpers, required} from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import {getBaseUrl} from "@/helpers/baseUrl";
import Multiselect from "@vueform/multiselect";


export default {
  page: {
    title: "Representantes",
    meta: [{ descricao: "description", content: appConfig.description }]
  },
  setup() {
    return { v$: useVuelidate() };
  },
  components: { Layout, PageHeader, Loader, Vue3Lottie, Multiselect },
  data() {
    return {
      AstronautJSON,
      title: 'Config. Representantes',
      items: [
        {
          text: 'Administrativo',
          href: '/',
        },
        {
          text: 'Config. Repres.',
          active: true,
        },
      ],
      errosValid: null,
      loadingListEquipe: true,
      loadingListFaixa: true,
      loadingGraph: true,
      equipeRepresList: null,
      faixaRepresList:null,
      bancoList: null,
      contaData: null,
      represChart1: representantesChart1,
      represChart2: representantesChart2,
      pesqTextFilterEq: '',
      pesqTextFilterFx: '',
      statusFilter: 'T',

      regSelecionadoFaixa: {
        status: "A"
      },
      regSelecionadoEquipe: {
        status: "A"
      },
      submitted: false,
      submittedFx: false,
      showModalEquipe: false,
      showModalFaixa: false,
      dtListPesqEmpresa: [],
    }
  },

  validations: {
    regSelecionadoEquipe :{
      nome: {
        required: helpers.withMessage("Campo Nome obrigatório, favor preencher.", required),
      },
      status: {
        required: helpers.withMessage("Campo Status obrigatório, favor preencher.", required),
      },
    },

    regSelecionadoFaixa :{
      descricao: {
        required: helpers.withMessage("Favor preencher campos obrigatórios.", required),
      },
    }
  },

  methods: {
    pesqEmpresa(evt) {
      console.log('pesqEmpresa')
      console.log(evt)

      let query = evt

      if (query.length > 1) {
        api.get(`${getBaseUrl()}api/emprepesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)

          this.dtListPesqEmpresa = res.data
        })
      }
    },

    exportExcel(){
      console.log('exportExcel')
      const data = this.equipeRepresList
      const fileName = "exp_dados";
      const exportType = exportFromJSON.types.xls;
      if (data) exportFromJSON({ data, fileName, exportType });
    },

    atualizaDataList(){
      this.loadingListEquipe = true
      this.loadingListFaixa = true
      api.get(`${getBaseUrl()}api/repres`, {
        params: {
          'qe': this.pesqTextFilterEq,
          'se': this.statusFilter,
          'qf': this.pesqTextFilterFx
        }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        if (res.data.error){
          console.log(res.data.error)
          this.$router.push(`/faltapermissao`);
        }else{
          this.equipeRepresList = res.data[0]

          this.equipeRepresList.forEach(element => {
            element.porcent = this.formatDecimal(element.porcent)
          });

          this.faixaRepresList = res.data[1]
          this.bancoList = res.data[2]
          this.title = 'Config. Representantes'
          this.loadingListEquipe = false
          this.loadingListFaixa = false
          this.loadingGraph = false

          this.contaData = res.data[3]
        }
      });
    },

    deletaRegFaixa(dataID){
      console.log('deletaRegFaixa dataid:')
      console.log(dataID)

      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Registro",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.faixaRepresList = null
          this.loadingListFaixa = true
          api.delete(`${getBaseUrl()}api/represfaixa`, {
            params: {
              'iddata': dataID
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)

            if (res.data.success) {
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: res.data.message,
                showConfirmButton: false,
                timer: 1500
              }).then(() => {
                this.atualizaDataList()
              })
            } else {
              Swal.fire({
                position: "top-end",
                icon: "error",
                title: res.data.error,
                showConfirmButton: false,
                timer: 1500
              })
            }
          })
        }
      })
    },

    deletaRegEquipe(dataID){
      console.log('deletaRegEquipe dataid:')
      console.log(dataID)

      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Registro",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.equipeRepresList = null
          this.loadingListEquipe = true
          api.delete(`${getBaseUrl()}api/represequipe`, {
            params: {
              'iddata': dataID
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)

            if (res.data.success) {
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: res.data.message,
                showConfirmButton: false,
                timer: 1500
              }).then(() => {
                this.atualizaDataList()
              })
            } else {
              Swal.fire({
                position: "top-end",
                icon: "error",
                title: res.data.error,
                showConfirmButton: false,
                timer: 1500
              })
            }
          })
        }
      })
    },

    formSubmitFaixa() {
      console.log('formSubmitEquipe_0')
      this.submittedFx = true
      this.v$.$touch()
      if(!this.regSelecionadoFaixa.descricao ||
          !this.regSelecionadoFaixa.maximofat ||
          !this.regSelecionadoFaixa.minimofat ||
          !this.regSelecionadoFaixa.percentmin ||
          !this.regSelecionadoFaixa.percentmax ||
          !this.regSelecionadoFaixa.valormin ||
          !this.regSelecionadoFaixa.valormax
         ){
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: this.v$.regSelecionadoFaixa.descricao.required.$message,
          showConfirmButton: false,
          timer: 1500
        })
        this.submittedFx = false
        return
      }
        this.showModalFaixa = false
        this.alterouRegFaixa(this.regSelecionadoFaixa)

      Swal.fire({
        position: "top-end",
        icon: "success",
        title: "Registro salvo com sucesso!",
        showConfirmButton: false,
        timer: 1500
      })

      this.submittedFx = false
    },

    formSubmitEquipe() {
      console.log('formSubmitEquipe_0')
      this.submitted = true
      this.v$.$touch()
      if(!this.regSelecionadoEquipe.nome){
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: this.v$.regSelecionadoEquipe.nome.required.$message,
          showConfirmButton: false,
          timer: 1500
        })
      } else {
        console.log('formSubmitEquipe_validado')
        this.showModalEquipe = false
        this.alterouRegEquipe(this.regSelecionadoEquipe)
      }
      this.submitted = false
    },

    alterouRegFaixa(regSelecionadoFaixa) {
      console.log('alterouRegFaixa')
      console.log(regSelecionadoFaixa)
      this.faixaRepresList = null
      this.loadingListFaixa = true
      this.errosValid = []
      api.post(`${getBaseUrl()}api/represfaixa`, {
        represDataFaixa: regSelecionadoFaixa
      }).then((res) => {
        console.log('then axios')
        console.log(res)
        this.loadingListFaixa = false

        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Informações salvas com sucesso!",
          showConfirmButton: false,
          timer: 1500
        })

        this.atualizaDataList()

      }).catch((err) => {
        console.log('erro axios')
        // console.log(err)
        // console.log(err.response)
        // console.log(err.response.data.errors)
        let erros = err.response.data.errors
        console.log(erros)
        console.log(typeof  erros)
        let listaErros = []
        Object.keys(erros).forEach(key => {
          console.log(key, erros[key]);
          listaErros.push({
            'titulo': key,
            'mensagem': erros[key]
          })
        });
        this.errosValid = listaErros
      }).finally(()=>{
        this.atualizaDataList()
      })
    },

    alterouRegEquipe(regSelecionadoEquipe) {
      console.log('alterouRegEquipe')
      console.log(regSelecionadoEquipe)
      this.equipeRepresList = null
      this.loadingListEquipe = true
      this.errosValid = []
      api.post(`${getBaseUrl()}api/represequipe`, {
        repreData: regSelecionadoEquipe
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        // this.produtoData = res.data[0]
        this.loadingListEquipe = false

        if (res.data.error) {
          Swal.fire({
            position: "top-end",
            icon: "error",
            title: res.data.error,
            showConfirmButton: false,
            timer: 1500
          })
        } else {
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          }).then(() => {
            this.atualizaDataList()
          })
        }
      }).catch((err) => {
        console.log('erro axios')
        // console.log(err)
        // console.log(err.response)
        // console.log(err.response.data.errors)
        let erros = err.response.data.errors
        console.log(erros)
        console.log(typeof  erros)
        let listaErros = []
        Object.keys(erros).forEach(key => {
          console.log(key, erros[key]);
          listaErros.push({
            'titulo': key,
            'mensagem': erros[key]
          })
        });
        this.errosValid = listaErros
      }).finally(()=>{
        this.atualizaDataList()
      })
    },

    criarNovaFaixa() {
      console.log('criarNova')
      this.regSelecionadoFaixa = {
        status: "A",
      }
      this.submittedFx = false
      this.showModalFaixa = true

    },

    criarNovaEquipe() {
      console.log('criarNova')
      // this.$refs.childTableEquipe.setCriarNovaEquipe(true)
      // this.$refs.childTableFaixa.setCriarNovaFaixa(true)
      this.regSelecionadoEquipe = {
        status: "A",
      }
      this.submitted = false
      this.showModalEquipe = true

    },

    editarFaixa(dataID){
      console.log('editar: ' + dataID)
      this.showModalFaixa = true
      this.regSelecionadoFaixa = this.faixaRepresList.find((reg) => reg.id === dataID);
      // console.log('regSelecionadoEquipe: ')
      // console.log(this.regSelecionadoFaixa)
    },

    editarEquipe(dataID){
      console.log('editar: ' + dataID)
      this.showModalEquipe = true
      this.regSelecionadoEquipe = this.equipeRepresList.find((reg) => reg.id === dataID);
      // console.log('regSelecionadoEquipe: ')
      // console.log(this.regSelecionadoEquipe)
    },

    nomeStatus(strEntr){
      let result = 'Não Definido'
      switch (strEntr) {
        case 'A':
          result = 'Ativo'
          break
        default:
          result = 'Inativo'
          break
      }
      return result
    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return 0.00;
    },

    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY HH:mm:ss"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

    formatDate(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },
  },
  mounted() {
    console.log('mounted repres-list_0')
    this.atualizaDataList()
  },
}
</script>

<template>
  <Layout>

    <span class="float-end" style="z-index: 1000; position: absolute; top: 35px; right: 200px;">
      <Vue3Lottie :animationData="AstronautJSON" :height="220" :width="220" />
    </span>

    <PageHeader :title="title" :items="items" />

    <div class="card">
      <div class="card-body">
        <div class="row justify-content-center">

          <div class="row col-6">
            <div class="row mb-4">

              <div class="mb-4">
                <h5>({{ this.faixaRepresList?.length }}) Faixas Representantes</h5>
              </div>

              <div class="col-sm-3">
                <div class="search-box me-2 mb-2 d-inline-block">
                  <div class="position-relative">
                    <input
                        id="inputPesquisa"
                        type="text"
                        v-model="pesqTextFilterFx"
                        class="form-control"
                        placeholder="Enter para pesquisar..."
                        @change="atualizaDataList"/>
                    <i class="bx bx-search-alt search-icon"></i>
                  </div>
                </div>
              </div>

              <div class="col-sm-3">
                <div class="search-box me-2 mb-2 d-inline-block">
                  <div class="row position-relative">
                    <div class="col-4">
                      <b-button variant="outline-primary" class="" @click="exportExcel">
                        <i class="bx bx-export font-size-16 align-middle "></i>
                      </b-button>
                    </div>

                  </div>
                </div>
              </div>

              <div class="col-sm-6">
                <div class="text-sm-end">
                  <button type="button" class="btn btn-success btn-rounded mb-2 me-2" @click="criarNovaFaixa">
                    <i class="mdi mdi-plus me-1"></i> Nova Faixa
                  </button>
                </div>
              </div>
            </div>

            <Loader v-if="loadingListFaixa" style="min-height: 300px;">
            </Loader>

            <div class="table-responsive mb-0" style="min-height: 400px; max-height: 400px; overflow-y: auto;">
              <table class="table align-middle table-nowrap" v-if="faixaRepresList"  style="min-width: 500px;">
                <thead class="table-light">
                  <tr>
                    <th class="align-middle">ID</th>
  <!--                  <th class="align-middle">Empresa</th>-->
                    <th class="align-middle">Descrição</th>
                    <!--        <th class="align-middle">Email</th>-->
                    <th class="align-middle">Mín. Fat.</th>
                    <th class="align-middle">Máx. Fat.</th>
                    <th class="align-middle">Vlr. Mín.</th>
                    <th class="align-middle">Vlr. Máx.</th>
                    <th class="align-middle">Mín. %</th>
                    <th class="align-middle">Máx. %</th>
  <!--                  <th class="align-middle">Criação</th>-->
                    <th class="text-center">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="data in faixaRepresList" :key="data.id">
                    <td>
                      <a href="javascript: void(0);" class="text-body fw-bold" @click="editarFaixa(data.id)">{{
                          data.id
                        }}</a>
                    </td>
    <!--                  <td>{{ data.empresa }} </td>-->
                    <td>{{ data.descricao }} </td>
                    <!--        <td>{{ data.email }} </td>-->
                    <td>{{ formatDecimal(data.minimofat) }}</td>
                    <td>{{ formatDecimal(data.maximofat) }}</td>
                    <td>{{ formatDecimal(data.valormin) }}</td>
                    <td>{{ formatDecimal(data.valormax) }}</td>
                    <td>{{ formatDecimal(data.percentmin) }} %</td>
                    <td>{{ formatDecimal(data.percentmax) }} %</td>
                    <td class="text-center">
                      <div class="button-items">
                        <b-button variant="outline-success" @click="editarFaixa(data.id)">
                          <i class="mdi mdi-pencil d-block font-size-16"></i>
                        </b-button>
                        <b-button variant="outline-danger" @click="deletaRegFaixa(data.id)">
                          <i class="mdi mdi-trash-can d-block font-size-16"></i>
                        </b-button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <ul class="pagination pagination-rounded justify-content-end mb-2">
              <li class="page-item disabled">
                <a class="page-link" href="javascript: void(0);" aria-label="Previous">
                  <i class="mdi mdi-chevron-left"></i>
                </a>
              </li>
              <li class="page-item active">
                <a class="page-link" href="javascript: void(0);">1</a>
              </li>

              <li class="page-item disabled">
                <a class="page-link" href="javascript: void(0);" aria-label="Next">
                  <i class="mdi mdi-chevron-right"></i>
                </a>
              </li>
            </ul>
          </div>

          <div v-if="!loadingListFaixa" class="col-auto d-flex justify-content-center mx-2">
            <div style="width: 1px; background-color: #dee2e6; min-height: 100%;"></div>
          </div>

          <div class="row col-6">
            <div class="row mb-4">

              <div class="mb-4">
                <h5>({{ this.equipeRepresList?.length }}) Equipes Representantes</h5>
              </div>

              <div class="col-sm-3">
                <div class="search-box me-2 mb-2 d-inline-block">
                  <div class="position-relative">
                    <input
                        id="inputPesquisa"
                        type="text"
                        v-model="pesqTextFilterEq"
                        class="form-control"
                        placeholder="Enter para pesquisar..."
                        @change="atualizaDataList"/>
                    <i class="bx bx-search-alt search-icon"></i>
                  </div>
                </div>
              </div>

              <div class="col-sm-3">
                <div class="search-box me-2 mb-2 d-inline-block">
                  <div class="row position-relative">
                    <div class="col-8">
                      <select
                          id="selectStatus"
                          v-model="statusFilter"
                          @change="atualizaDataList"
                          class="form-control select2-search-disable">
                        <option value="T" selected>Todos</option>
                        <option value="A">Ativos</option>
                        <option value="I">Inativos</option>
                      </select>
                      <i class="bx bx-filter-alt search-icon ms-3"></i>
                    </div>
                    <div class="col-4">
                      <b-button variant="outline-primary" class="" @click="exportExcel">
                        <i class="bx bx-export font-size-16 align-middle "></i>
                      </b-button>
                    </div>

                  </div>
                </div>
              </div>

              <div class="col-sm-6">
                <div class="text-sm-end">
                  <button type="button" class="btn btn-success btn-rounded mb-2 me-2" @click="criarNovaEquipe">
                    <i class="mdi mdi-plus me-1"></i> Nova Equipe
                  </button>
                </div>
              </div>
            </div>

            <Loader v-if="loadingListEquipe" style="min-height: 300px;">
            </Loader>

<!--            <RepresTable
                ref="childTableEquipe"
                :equipeRepresList="equipeRepresList"
                :bancoList="bancoList"
                :contaDataList="contaData"
                @deletareg="deletaReg"
                @alterareg="alterouReg"/>-->

            <div class="table-responsive mb-0" style="min-height: 400px; max-height: 400px; overflow-y: auto;">
              <table class="table align-middle table-nowrap" v-if="equipeRepresList" style="min-width: 500px;">
                <thead class="table-light">
                <tr>

                  <th class="align-middle">ID</th>
                  <th class="align-middle">Empresa</th>
                  <th class="align-middle">Nome</th>
                  <!--        <th class="align-middle">Email</th>-->
                  <th class="align-middle">Porcent. Equipe</th>
                  <th class="align-middle">Status</th>
                  <th class="align-middle">Criação</th>
                    <th class="align-middle">Atualização</th>



 
                  <th class="text-center">Ações</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="data in equipeRepresList" :key="data.id">
                  <td>
                    <a href="javascript: void(0);" class="text-body fw-bold" @click="editarEquipe(data.id)">{{
                        data.id
                      }}</a>
                  </td>
                  <td>{{ data.empresa }} </td>
                  <td>{{ data.nome }} </td>
                  <!--        <td>{{ data.email }} </td>-->
                  <td>{{ data.porcent }} %</td>
                  <td>
                <span
                    class="badge badge-pill badge-soft-success font-size-11"
                    :class="data.status === 'A' ? 'badge-soft-success' : 'badge-soft-danger'">
                  {{ nomeStatus(data.status)  }}
                </span>
                  </td>
                  <td>{{ formatDate(data.created_at) }} </td>
                    <td>{{ data.updated_at ? formatDate(data.updated_at) : "-" }} </td>
 
                  <td class="text-center">
                    <div class="button-items">
                      <b-button variant="outline-success" @click="editarEquipe(data.id)">
                        <i class="mdi mdi-pencil d-block font-size-16"></i>
                      </b-button>
                      <b-button variant="outline-danger" @click="deletaRegEquipe(data.id)">
                        <i class="mdi mdi-trash-can d-block font-size-16"></i>
                      </b-button>
                    </div>
                  </td>

                </tr>
                </tbody>
              </table>
            </div>

            <ul class="pagination pagination-rounded justify-content-end mb-2">
              <li class="page-item disabled">
                <a class="page-link" href="javascript: void(0);" aria-label="Previous">
                  <i class="mdi mdi-chevron-left"></i>
                </a>
              </li>
              <li class="page-item active">
                <a class="page-link" href="javascript: void(0);">1</a>
              </li>

              <li class="page-item disabled">
                <a class="page-link" href="javascript: void(0);" aria-label="Next">
                  <i class="mdi mdi-chevron-right"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <b-alert v-for="(erro, i) in errosValid" :key="`alerta-${i}`"   show dismissible variant="danger" >
      <i class="mdi mdi-alert me-2"></i>Pendente validação de campo: {{ erro.titulo }} -- {{ erro.mensagem[0] }} --
      favor ajustar e tentar novamente.
    </b-alert>

    <b-modal :title="regSelecionadoEquipe.id != null ? `Editar Equipe Representante (${ regSelecionadoEquipe.id })` : 'Criar Nova Equipe Representante'"
             v-model="showModalEquipe" size="lg" hide-footer>
      <form @submit.prevent="formSubmitEquipe">
        <div class="row">
          <div class="col-6 mb-2">
            <span class="mb-2" for="empresa">Empresa</span>
            <multiselect id="empresa" @search-change="pesqEmpresa" v-model="regSelecionadoEquipe.empresa"
              placeholder="Pesquisar Empresa" :options="dtListPesqEmpresa" :searchable="true" track-by="codigo"
              label="nome" value-prop="codigo">
              <template #option="slotProps">
                <div class="row">
                  <div>
                    <span class="text-info">
                      {{ slotProps.option.cnpj }}
                    </span>
                    <span class="mx-4">
                    </span>
                  </div>
                  <div class="mt-2 font-size-20">{{ slotProps.option.nome }}</div>
                  <span class="mx-4">
                  </span>
                  <span class="mx-4">
                  </span>
                  <div class="align-items-end text-end align-content-end">Código: {{ slotProps.option.codigo }} </div>
                </div>
              </template>
            </multiselect>
          </div>

          <div class="col-8">
            <div class="mb-3">
              <label for="nome">Nome</label>
              <input
                  id="nome"
                  v-model="regSelecionadoEquipe.nome"
                  type="text"
                  class="form-control"
                  placeholder="Inserir nome"
                  :class="{'is-invalid': submitted && v$.regSelecionadoEquipe?.nome.$error,}"/>
              <div
                  v-if="submitted && v$.regSelecionadoEquipe?.nome.$error"
                  class="invalid-feedback">
                <span v-if="v$.regSelecionadoEquipe?.nome.required.$message">
                  {{ v$.regSelecionadoEquipe?.nome.required.$message }}
                </span>
              </div>
            </div>
          </div>

          <div class="col-4">
            <div class="mb-3">
              <label for="selectStatus">Status</label>
              <b-form-select
                  id="selectStatus"
                  v-model="regSelecionadoEquipe.status"
                  class="mb-3 form-select form-control"
                  :class="{'is-invalid': submitted && v$.regSelecionadoEquipe?.status.$error,}">
                <b-form-select-option value="A">
                  Ativo
                </b-form-select-option>
                <b-form-select-option value="I">
                  Inativo
                </b-form-select-option>
                <b-form-select-option value="L">
                  Análise
                </b-form-select-option>
              </b-form-select>
              <div v-if="submitted && v$.regSelecionadoEquipe?.status.$error" class="invalid-feedback">
                <span v-if="v$.regSelecionadoEquipe?.status.required.$message">
                  {{ v$.regSelecionadoEquipe?.status.required.$message }}
                </span>
              </div>
            </div>
          </div>

          <div class="col-8">
            <div class="mb-3">
              <label for="email">Email</label>
              <input
                  id="email"
                  v-model="regSelecionadoEquipe.email"
                  type="text"
                  class="form-control"
                  placeholder="Inserir email"/>
            </div>
          </div>

          <div class="col-4">
            <div class="mb-3">
              <label for="porcent">Percentual</label>
              <input
                  id="porcent"
                  v-model="regSelecionadoEquipe.porcent"
                  type="text"
                  class="form-control"
                  placeholder="Inserir o valor percentual"/>

            </div>
          </div>

          <div class="text-end mt-3">
            <b-button variant="light" @click="showModalEquipe = false">
              <i class="bx bx-block font-size-16 align-middle me-2"></i>
              Fechar
            </b-button>
            <b-button variant="success" class="ms-1" @click="formSubmitEquipe">
              <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
              Confirmar
            </b-button>
          </div>
        </div>
      </form>
    </b-modal>

    <b-modal :title="regSelecionadoFaixa.id != null ? `Editar Faixa Representante (${ regSelecionadoFaixa.id })` : 'Criar Nova Faixa Representante'"
             v-model="showModalFaixa" size="lg" hide-footer>
      <form @submit.prevent="formSubmitFaixa">
        <div class="row">
          <div class="col-6 mb-2">
            <span class="mb-2" for="empresa">Empresa</span>
            <multiselect id="empresa" @search-change="pesqEmpresa" v-model="regSelecionadoFaixa.empresa"
                         placeholder="Pesquisar Empresa" :options="dtListPesqEmpresa" :searchable="true" track-by="codigo"
                         label="nome" value-prop="codigo">
              <template #option="slotProps">
                <div class="row">
                  <div>
                    <span class="text-info">
                      {{ slotProps.option.cnpj }}
                    </span>
                    <span class="mx-4">
                    </span>
                  </div>
                  <div class="mt-2 font-size-20">{{ slotProps.option.nome }}</div>
                  <span class="mx-4">
                  </span>
                  <span class="mx-4">
                  </span>
                  <div class="align-items-end text-end align-content-end">Código: {{ slotProps.option.codigo }} </div>
                </div>
              </template>
            </multiselect>
          </div>

          <div class="col-8 mb-2">
            <div class="mb-3">
              <label for="descricao">Descrição</label>
              <input
                  id="descricao"
                  v-model="regSelecionadoFaixa.descricao"
                  type="text"
                  class="form-control"
                  placeholder="Inserir descrição"
                  :class="{'is-invalid': submittedFx && v$.regSelecionadoFaixa.descricao.$error,}"/>
              <div
                  v-if="submittedFx && v$.regSelecionadoFaixa.descricao.$error"
                  class="invalid-feedback">
                <span v-if="v$.regSelecionadoFaixa.descricao.required.$message">
                  {{ v$.regSelecionadoFaixa.descricao.required.$message }}
                </span>
              </div>
            </div>
          </div>

          <div class="col-4"></div>

          <div class="col-3">
            <div class="mb-3">
              <label for="minfaturado">Mín. Faturado</label>
              <input id="minfaturado"
                     v-model="regSelecionadoFaixa.minimofat"
                     type="number"
                     class="form-control"
                     placeholder="Mínimo Faturado"
                     required />
                <div>
                  <span class="text-danger">* Campo obrigatório.</span>
                </div>
            </div>
          </div>


          <div class="col-3">
            <div class="mb-3">
              <label for="maxfaturado">Máx. Faturado</label>
              <input id="maxfaturado"
                     v-model="regSelecionadoFaixa.maximofat"
                     type="number"
                     class="form-control"
                     placeholder="Máximo Faturado"
                     required/>
              <!--                      <div v-if="submmitedVeicFxData && !pessoaVeicFxData.maximo" class="invalid-feedback">
                                      <span>Campo máximo obrigatório e válido, favor corrigir.</span>
                                    </div>-->
              <div>
                <span class="text-danger">* Campo obrigatório.</span>
              </div>
            </div>
          </div>

          <div class="col-3">
            <div class="mb-3">
              <label for="minvalor">Vlr Mínimo</label>
              <input id="minvalor"
                     v-model="regSelecionadoFaixa.valormin"
                     type="number"
                     class="form-control"
                     placeholder="Valor Mínimo"
                     required/>
              <div>
                <span class="text-danger">* Campo obrigatório.</span>
              </div>
            </div>
          </div>

          <div class="col-3">
            <div class="mb-3">
              <label for="maxvalor">Vlr Máximo</label>
              <input id="maxvalor"
                     v-model="regSelecionadoFaixa.valormax"
                     type="number"
                     class="form-control"
                     placeholder="Valor Máximo"
                     required/>
              <div>
                <span class="text-danger">* Campo obrigatório.</span>
              </div>
            </div>
          </div>

          <div class="col-3">
            <div class="mb-3">
              <label for="minpercent">Percent. Mín</label>
              <input id="minpercent"
                     v-model="regSelecionadoFaixa.percentmin"
                     type="number"
                     class="form-control"
                     placeholder="Percent. Mínimo"
                     required/>
              <div>
                <span class="text-danger">* Campo obrigatório.</span>
              </div>
            </div>
          </div>

          <div class="col-3">
            <div class="mb-3">
              <label for="maxpercent">Percent. Máx</label>
              <input id="maxpercent"
                     v-model="regSelecionadoFaixa.percentmax"
                     type="number"
                     class="form-control"
                     placeholder="Percent. Máximo"
                     required/>
              <div>
                <span class="text-danger">* Campo obrigatório.</span>
              </div>
            </div>
          </div>

          <hr class=" mt-4">

          <div class="text-end mt-3">
            <b-button variant="light" @click="showModalFaixa = false">
              <i class="bx bx-block font-size-16 align-middle me-2"></i>
              Fechar
            </b-button>
            <b-button variant="success" class="ms-1" @click="formSubmitFaixa">
              <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
              Confirmar
            </b-button>
          </div>
        </div>
      </form>

    </b-modal>
  </Layout>
</template>
